import React from 'react';
import TextField from '@mui/material/TextField';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { SxProps, Theme } from '@mui/material';

interface EurCurrencyFieldProps
  extends Omit<
    NumericFormatProps,
    'value' | 'onValueChange' | 'customInput' | 'onChange' | 'size' | 'color'
  > {
  value: number | null; // Value in cents
  onChange?: (value: number | null) => void; // Callback with value in cents
  label?: string;
  allowDecimalScale?: boolean;
  helperText?: string;
  error?: boolean;
  sx?: SxProps<Theme>;
  size?: 'small' | 'medium';
}

// Component to input amounts in euros, but handle values in cents internally
// Uses European formatting: dot as thousand separator, comma as decimal separator
// Example: 1.234,56 €
export const EurCurrencyField: React.FC<EurCurrencyFieldProps> = ({
  value,
  onChange,
  label,
  allowDecimalScale = true,
  ...rest
}) => {
  const displayValue = value !== null ? value / 100 : null;

  return (
    <NumericFormat
      value={displayValue ?? ''}
      decimalScale={allowDecimalScale ? 2 : 0}
      fixedDecimalScale
      allowNegative={false}
      thousandSeparator={'.'}
      decimalSeparator={','}
      prefix={''}
      suffix={' €'}
      customInput={TextField}
      label={label}
      fullWidth
      onValueChange={({ floatValue }) => {
        // Convert euros back to cents
        const centsValue =
          floatValue !== undefined && floatValue !== null ? Math.round(floatValue * 100) : null;
        onChange?.(centsValue);
      }}
      {...rest}
    />
  );
};

export default EurCurrencyField;
